<template>
    <v-dialog v-model="dialog" max-width="750" content-class="modal-redirecionar"
        @click:outside="fechar" @keydown.esc="fechar">
        <v-card ref="card" class="mr-card" role="dialog" aria-modal="true"
            :aria-labelledby="tituloId" :aria-describedby="descId">

            <div class="mr-header">
                <h2 :id="tituloId" class="mr-titulo">VOCÊ SERÁ REDIRECIONADO</h2>
                <button ref="btnFechar" type="button" class="mr-fechar"
                    aria-label="Fechar" @click="fechar">
                    <v-icon color="#FFFFFF" size="16">fas fa-xmark</v-icon>
                </button>
            </div>

            <div class="mr-icone">
                <v-icon color="#32ACB9" size="40">fas fa-arrow-up-right-from-square</v-icon>
            </div>

            <div class="mr-corpo">
                <p :id="descId" class="mr-texto">
                    Para enviar a folha de ponto assinada,
                    <strong>você será redirecionado para outra página</strong>,
                    que será aberta em uma nova aba do navegador!
                </p>

                <div class="mr-acoes">
                    <v-btn text class="mr-btn-cancelar" @click="fechar">Cancelar</v-btn>
                    <v-btn depressed class="mr-btn-continuar" @click="continuar">
                        <v-icon left size="16">fas fa-arrow-up-right-from-square</v-icon>
                        Continuar
                    </v-btn>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "modal-redirecionar-folha",
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: this.value,
            tituloId: "modal-redirecionar-titulo",
            descId: "modal-redirecionar-descricao",
        };
    },
    watch: {
        value(novo) {
            this.dialog = novo;
            if (novo) this.focarInicial();
        },
        dialog(novo) {
            // Mantém o v-model do pai sincronizado quando o Vuetify fecha
            // internamente (ESC ou clique fora).
            if (novo !== this.value) this.$emit("input", novo);
        },
    },
    methods: {
        focarInicial() {
            this.$nextTick(() => {
                const alvo = this.$refs.btnFechar;
                if (alvo) alvo.focus();
            });
        },
        fechar() {
            this.dialog = false;
            this.$emit("input", false);
            this.$emit("fechar");
        },
        continuar() {
            this.$emit("continuar");
            this.fechar();
        },
    },
};
</script>

<style scoped>
.mr-card {
    border-radius: 20px !important;
    padding-bottom: 16px;
    overflow: hidden;
}

.mr-header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 56px;
    padding: 10px 32px;
    background-color: #008693;
}

.mr-titulo {
    color: #ffffff;
    font-family: Montserrat, sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    margin: 0;
}

.mr-fechar {
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background: transparent;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.mr-fechar:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
}

.mr-icone {
    display: flex;
    justify-content: center;
    padding-top: 24px;
}

.mr-corpo {
    display: flex;
    flex-direction: column;
    padding: 16px 32px 0;
    gap: 32px;
}

.mr-texto {
    color: #161616;
    font-family: Lato, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    margin: 0;
}

.mr-texto strong {
    font-weight: 700;
}

.mr-acoes {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    padding-top: 24px;
    border-top: 1px solid #278b97;
}

.mr-btn-cancelar {
    min-width: 124px !important;
    height: 40px !important;
    border: 1px solid #2d2d2d !important;
    border-radius: 10px !important;
    color: #2d2d2d !important;
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    font-size: 14px;
    text-transform: none;
    letter-spacing: 0;
}

.mr-btn-continuar {
    height: 40px !important;
    padding: 10px 24px !important;
    background-color: #32acb9 !important;
    color: #ffffff !important;
    border-radius: 10px !important;
    font-family: Lato, sans-serif;
    font-weight: 800;
    font-size: 14px;
    text-transform: none;
    letter-spacing: 0;
    box-shadow: none !important;
}

@media screen and (max-width: 600px) {
    .mr-acoes {
        flex-direction: column-reverse;
    }

    .mr-btn-cancelar,
    .mr-btn-continuar {
        width: 100%;
    }
}
</style>
